"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledScrollableTable = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireWildcard(require("react"));
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _APTooltip = require("../Tooltip/APTooltip");
var _external = require("../external");
var _StyledTable = require("./StyledTable.styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var StyledScrollableTable = function StyledScrollableTable(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    testId = _ref.testId,
    className = _ref.className,
    _ref$characterLength = _ref.characterLength,
    characterLength = _ref$characterLength === void 0 ? 30 : _ref$characterLength,
    sectionWidths = _ref.sectionWidths,
    _ref$sidebarWidth = _ref.sidebarWidth,
    sidebarWidth = _ref$sidebarWidth === void 0 ? 0 : _ref$sidebarWidth;
  var classes = (0, _StyledTable.useStyles)();
  var tableRef = (0, _react.useRef)();
  var containerTableRef = (0, _react.useRef)();
  var tableCellRefs = (0, _react.useRef)(columns.map(function () {
    return /*#__PURE__*/(0, _react.createRef)();
  }));
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    farLeft = _useState2[0],
    setFarLeft = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    farRight = _useState4[0],
    setFarRight = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    width = _useState6[0],
    setWidth = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    accuringWidths = _useState8[0],
    setAccuringWidths = _useState8[1];
  (0, _react.useEffect)(function () {
    var original = tableCellRefs.current.map(function (r) {
      return r.current.offsetWidth;
    });
    var compoundingArray = [];
    original.forEach(function (el, it) {
      compoundingArray.push(el + (compoundingArray[it - 1] || 0));
    });
    compoundingArray.unshift(0);
    compoundingArray[sectionWidths.left + sectionWidths.middle] = compoundingArray[sectionWidths.left + sectionWidths.middle] + 8;
    setAccuringWidths(compoundingArray);
  }, []);
  var formatString = function formatString(text) {
    var output = text;
    if ((text === null || text === void 0 ? void 0 : text.length) > characterLength) {
      output = /*#__PURE__*/_react["default"].createElement(_APTooltip.APTooltip, {
        placement: "bottom",
        arrow: true,
        title: text
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: classes.amendmentHistoryTooltip
      }, /*#__PURE__*/_react["default"].createElement("span", null, text.substring(0, characterLength), "...")));
    }
    return output;
  };
  var renderTableBody = function renderTableBody(items) {
    return items.map(function (record, i) {
      return /*#__PURE__*/_react["default"].createElement(_external.TableRow, {
        key: i,
        className: classes.scrollableLink
      }, columns.map(function (column, j) {
        return /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
          ref: tableCellRefs.current[j],
          className: (0, _clsx["default"])(classes.text, j < sectionWidths.left && !farLeft ? classes.stickyLeft : undefined, j + 1 > sectionWidths.left + sectionWidths.middle ? classes.stickyRight : undefined, j + 1 === sectionWidths.left && !farLeft ? classes.stickyLeftBorder : undefined, j === sectionWidths.left + sectionWidths.middle && !farRight ? classes.stickyRightBorder : undefined),
          key: j,
          align: column.align,
          style: {
            borderBottom: i === items.length - 1 ? 'none' : undefined,
            borderCollapse: 'separate',
            left: accuringWidths && j < sectionWidths.left && !farLeft ? accuringWidths[j] : undefined,
            right: accuringWidths && j + 1 > sectionWidths.left + sectionWidths.middle ? accuringWidths[accuringWidths.length - 2] - accuringWidths[j] : undefined
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: column.width
          }
        }, ['string', 'number', 'boolean'].includes(_typeof(record[column.accessor])) ? formatString(record[column.accessor].toString()) : record[column.accessor]));
      }));
    });
  };
  var tableHead = function tableHead() {
    return /*#__PURE__*/_react["default"].createElement(_external.TableHead, null, /*#__PURE__*/_react["default"].createElement(_external.TableRow, null, columns.map(function (column, i) {
      return /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
        key: i,
        align: column.align,
        className: (0, _clsx["default"])(i < sectionWidths.left && !farLeft ? classes.stickyLeft : undefined, i + 1 > sectionWidths.left + sectionWidths.middle ? classes.stickyRight : undefined, i + 1 === sectionWidths.left && !farLeft ? classes.stickyLeftBorder : undefined, i === sectionWidths.left + sectionWidths.middle && !farRight ? classes.stickyRightBorder : undefined),
        style: {
          width: column.width,
          left: accuringWidths && i < sectionWidths.left && !farLeft ? accuringWidths[i] : undefined,
          right: accuringWidths && i + 1 > sectionWidths.left + sectionWidths.middle ? accuringWidths[accuringWidths.length - 2] - accuringWidths[i] : undefined
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: column.width
        }
      }, i + 1 > sectionWidths.left + sectionWidths.middle || i < sectionWidths.left ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        style: {
          marginRight: '5px',
          color: '#9A9A9A'
        },
        icon: _proSolidSvgIcons.faLock
      }) : undefined, typeof column.header === 'string' ? formatString(column.header) : column.header));
    })));
  };
  var onScroll = function onScroll() {
    var scrollLeft = Math.abs(tableRef.current.getBoundingClientRect().left - tableRef.current.offsetLeft - sidebarWidth);
    setFarLeft(!scrollLeft);
    var scrollRight = Math.abs(tableRef.current.getBoundingClientRect().right - width);
    setFarRight(!scrollRight);
  };
  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      containerTableRef.current.scrollLeft += 4000; // High number of pixels larger than screen
      setWidth(tableRef.current.getBoundingClientRect().right);
      containerTableRef.current.scrollLeft -= 4000;
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  (0, _react.useEffect)(function () {
    onScroll();
  }, [width]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_external.TableContainer, {
    onScroll: onScroll,
    ref: containerTableRef,
    className: classes.tableContainer
  }, /*#__PURE__*/_react["default"].createElement(_external.Table, {
    "data-testid": testId,
    className: (0, _clsx["default"])(classes.table, className),
    ref: tableRef
  }, tableHead(), data && data.length > 0 ? /*#__PURE__*/_react["default"].createElement(_external.TableBody, null, renderTableBody(data)) : null)));
};
exports.StyledScrollableTable = StyledScrollableTable;
var _default = StyledScrollableTable;
exports["default"] = _default;